/* eslint-disable */
import HttpService from '../HttpService'

export default class AttachmentTypeService {
    constructor() {
        this._httpService = new HttpService(`healthcare`);
    }

    async findAll(){
        return await this._httpService.get('/health_challenge');
    };

}
